import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {Reserva} from '../interfaces/utilidades/reservas.interface';

@Injectable({
  providedIn: 'root'
})

export class ReservaService {
  private apiUrl = 'https://camposdeportivos.muninuevochimbote.gob.pe/api/reserva'; // Cambia esta URL según tu API

  constructor(private http: HttpClient) { }

  getReservas(): Observable<Reserva[]> {
    return this.http.get<Reserva[]>(this.apiUrl);
  }

  getReservaById(id: number): Observable<Reserva> {
    return this.http.get<Reserva>(`${this.apiUrl}/${id}`);
  }

  // Crear una nueva reserva
  createReserva(reserva: Reserva): Observable<Reserva> {
    return this.http.post<Reserva>(this.apiUrl, reserva);
  }

// Actualizar una reserva
  updateReserva(reserva: Partial<Reserva>): Observable<Reserva> {
    return this.http.put<Reserva>(`${this.apiUrl}/${reserva.id}`, reserva);
  }

  // Eliminar una reserva
  deleteReserva(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }

  // Obtener reservas con la información simplificada (persona y otros detalles)
  getReservasSimplificadas(): Observable<any[]> {
    return this.http.get<Reserva[]>(this.apiUrl).pipe(
      map(reservas => reservas.map(reserva => {
        const persona = reserva.persona_natural
          ? { nombre: reserva.persona_natural.nombre_persona, dni: reserva.persona_natural.dni }
          : { nombre: reserva.persona_juridica?.razon_social || 'No disponible', ruc: reserva.persona_juridica?.ruc || 'No disponible' };

        return {
          id: reserva.id,
          persona: persona,
          estado: reserva.estado.descripcion,
          fechaReserva: reserva.fecha_reserva,
          horarioInicio: reserva.horario_inicio,
          horarioFin: reserva.horario_fin,
          campo: reserva.campo.nombre_campo,
          num_recibo: reserva.num_recibo || 'No disponible', // Asegúrate de que existe
          codigoPago: reserva.codigo_pago || 'No disponible',
          total: reserva.total,
          descuento: reserva.descuento,
          motivo_descuento: reserva.motivo_descuento// Asegúrate de que existe,
        };
      })),
    );
  }

  updateEstadoReserva(id: number, idEstado: number): Observable<Reserva> {
    const url = `${this.apiUrl}/${id}/estado`; // URL para actualizar el estado
    return this.http.patch<Reserva>(url, { id_estado: idEstado }); // Enviar directamente id_estado
  }

  getReservasForCalendar(): Observable<any[]> {
    return this.http.get<Reserva[]>(this.apiUrl).pipe(
      map(reservas => reservas.map(reserva => {
        return {
          fecha: reserva.fecha_reserva,  // Asegúrate de que la fecha esté en el formato adecuado
          horaInicio: reserva.horario_inicio,
          horaFin: reserva.horario_fin,
          campo: reserva.campo.nombre_campo,
          estado: reserva.estado.descripcion// Nombre del campo
        };
      }))
    );
  }
  updateNumRecibo(id: number, numRecibo: string): Observable<Reserva> {
    const url = `${this.apiUrl}/${id}/recibo`; // Construir la URL con el ID de la reserva
    return this.http.patch<Reserva>(url, { num_recibo: numRecibo }); // Enviar el número de recibo como cuerpo
  }

  updateFechaYHorarios(id: number, fechaReserva: string, horarios: number[]): Observable<Reserva> {
    const url = `${this.apiUrl}/${id}/editar`;
    return this.http.patch<Reserva>(url, { fecha_reserva: fechaReserva, horarios: horarios });
  }

  updateEstadoNoPagado(id: number): Observable<Reserva> {
    const url = `${this.apiUrl}/${id}/estado-no-pagado`; // URL para actualizar el estado a no pagado
    return this.http.put<Reserva>(url, {}); // Realizar la solicitud PATCH
  }

  calcularSubtotal(data: { id_campo: number, id_persona_juridica: number, id_tipo_dia: number, horarios: number[] }): Observable<number> {
    const url = `${this.apiUrl}s/calcular-subtotal`;
    return this.http.post<number>(url, data);
  }

  getReservaSimplificadaById(idReserva: number): Observable<any> {
    return this.http.get<Reserva>(`${this.apiUrl}/${idReserva}`).pipe(
      map(reserva => {
        return {
          razon_social: reserva.persona_juridica?.razon_social || 'No disponible',
          ruc: reserva.persona_juridica?.ruc || 'No disponible',
          celular: reserva.persona_juridica?.celular || 'No disponible',
          tipo_institucion: reserva.persona_juridica?.tipo_institucion?.nombre_institucion || 'No disponible',
          fechaReserva: reserva.fecha_reserva,
          horarioInicio: reserva.horario_inicio,
          horarioFin: reserva.horario_fin,
          campo: reserva.campo.nombre_campo,
          num_recibo: reserva.num_recibo || 'No disponible',
          total: reserva.total,
          descuento: reserva.descuento,
          motivo_descuento: reserva.motivo_descuento
        };
      })
    );
  }

}
